module.exports = __webpack_public_path__ + "img/dagajoga-logo-cut.e51f0bfd.png";